var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangedist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.50006C2.49958 6.399 2.86261 5.32859 3.53274 4.45494C4.20288 3.5813 5.14265 2.95329 6.20621 2.66836C7.26976 2.38344 8.39762 2.45754 9.41476 2.87916C10.4319 3.30078 11.2814 4.04635 11.8315 5.00016M12.5002 7.50006C12.5005 8.60102 12.1374 9.6713 11.4673 10.5448C10.7972 11.4184 9.8575 12.0463 8.79404 12.3312C7.73057 12.6161 6.60281 12.5421 5.58574 12.1206C4.56866 11.699 3.71914 10.9536 3.169 9.99996",
    stroke: "#5070DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75024 5.0001H11.875V1.875M6.25004 9.9999H3.12524V13.125",
    stroke: "#5070DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangedist);
export default __webpack_public_path__ + "static/media/changedist.0186ca861fa8700c5a4e54ae9bbf95ce.svg";
export { ForwardRef as ReactComponent };